export const STRIPE_URL = "https://buy.stripe.com/fZu7sL8Ap5N7dkk77cgnK05";
export const STRIPE_CONSULTING_URL = "https://buy.stripe.com/dRm6oHdUJb7r0xy2QWgnK06";
export const LINKEDIN_URL = "https://www.linkedin.com/in/francesc-riera-romea/";
export const INSTAGRAM_URL = "https://instagram.com/francescrierarrhh";
export const TALENTHEALTHCHECK_URL = "https://talenthealthcheck.com";
